module.exports = __webpack_public_path__ + "static/media/livescore-bg.e547acc2.png";